import {Injectable} from '@angular/core';

@Injectable()
export class CsAgGridJsService {

    constructor() {
    }

    updateNodeCellValue = (rowNode: any, rowData: object) => {
        if (rowData) {
            Object.entries(rowData).forEach(([key, val]) => rowNode['setDataValue'](key, val));
        }
    }
}
